import { Component, forwardRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { DefaultSelectComponent } from '../default-select/default-select.component';

@Component({
    selector: 'app-slot-interval-select',
    templateUrl: '../default-select/default-select.component.html',
    styleUrls: ['../default-select/default-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotIntervalSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SlotIntervalSelectComponent),
            multi: true
        }
    ]
})
export class SlotIntervalSelectComponent extends DefaultSelectComponent {

    constructor(injector: Injector) {
        super(injector);

        // Set default values
        this.label = 'pages.branches.deliveryTypeDialog.input.slotInterval';
        this.placeholderTranslationKey = 'pages.branches.timeSlotDialog.input.defaultInterval';

        // Override options with hard-coded interval values
        this.options = [
            { value: '5', label: '5 min' },
            { value: '10', label: '10 min' },
            { value: '15', label: '15 min' },
            { value: '20', label: '20 min' },
            { value: '25', label: '25 min' },
            { value: '30', label: '30 min' },
            { value: '35', label: '35 min' },
            { value: '40', label: '40 min' },
            { value: '45', label: '45 min' },
            { value: '50', label: '50 min' },
            { value: '55', label: '55 min' },
            { value: '60', label: '60 min' }
        ];
    }
}
